import React from 'react'
import { t } from "i18next";
import { Col, Row } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';
import Company from './Company';
import { OrderStatus } from '../data/enums';

function CompanyConfirmation({ giftee, orderNUm, chainName, companyProducts }) {
    const orderStatus = sessionStorage.getItem("orderStatusId")
    const company = useSelector((state) => state.company.company)
    const companyUser = useSelector((state) => state.company.companyUser)

    return (
        <>
            <div className="hidden-desk">
                <Company />
                <div className="border-underline-big"></div>
            </div>
            <div className="top-line comp-color black-text">
                <Row>
                    <Col md={9}>{t("ThanksForRsv") + chainName}</Col>
                    <Col className="top-rsv-num">{t("RsvNum")}{orderNUm}</Col>
                </Row>
            </div>
            <Row>
                <Col>
                    <div className="comp rvs-dtl border-left">
                        <div className="pb-4"><h4>{t("orderDetails")} {t("Number")} {orderNUm}</h4></div>
                        <div><h5>{companyProducts.selectedProduct.productName}</h5></div>
                        <div className="d-flex justify-content-between">
                            <h5>{t("price")}</h5>
                            <h5>
                                <NumberFormat className="prod-prc" role="application" aria-roledescription={t("price")}
                                    value={companyProducts.selectedProduct.productPriceAfterDiscount.toFixed(0)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={companyProducts.selectedProduct.currencyCode
                                        ? companyProducts.selectedProduct.currencyCode.replace("ILS", "₪")
                                        : companyProducts.selectedProduct.currencyCode}
                                />
                            </h5>
                        </div>
                        <div className="d-flex justify-content-between">
                            <h5>{t("quantity")}</h5>
                            <h5>{companyProducts.qty}</h5>
                        </div>
                        <div className="d-flex justify-content-between">
                            <h5>{t("total")}</h5>
                            <h5>
                                <NumberFormat className="prod-prc" role="application" aria-roledescription={t("price")}
                                    value={(companyProducts.qty * companyProducts.selectedProduct.productPriceAfterDiscount).toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={companyProducts.selectedProduct.currencyCode
                                        ? companyProducts.selectedProduct.currencyCode.replace("ILS", "₪")
                                        : companyProducts.selectedProduct.currencyCode}
                                />
                            </h5>
                        </div>
                        <div>
                            <h6>{t("willBeSentToTheList")}</h6>
                        </div>
                        {orderStatus == OrderStatus.Pending &&
                            <div className="result-small-info-box">
                                <h6>{t("bankTransferMsg")}</h6>
                                <h6 className="bg-light p-2" dangerouslySetInnerHTML={{ __html: t("bankTransferDetails").replaceAll('\n', '<br/>').replaceAll("חובה", "<b>חובה</b>").replaceAll("'", JSON.stringify("").charAt(0)) }}>
                                </h6>
                            </div>
                        }
                        <div className="border-underline mt-4 hidden-desk"></div>
                    </div>
                </Col>
                <Col>
                    {company && companyUser &&
                        <div className="comp rvs-dtl">
                            <div className="pb-4"><h4>{t("userDetails")}</h4></div>
                            <div className="d-flex justify-content-between mb-3">
                                <h6>{t("ContactFullName")}</h6>
                                <h6>{companyUser.customerFirstName} {companyUser.customerLastName}</h6>
                            </div>
                            <div className="d-flex justify-content-between mb-3">
                                <h6>{t("Email")}</h6>
                                <h6>{companyUser.customerEmail}</h6>
                            </div>
                            <div className="d-flex justify-content-between mb-3">
                                <h6>{t("CompanyName")}</h6>
                                <h6>{company.companyName}</h6>
                            </div>
                            <div className="d-flex justify-content-between mb-3">
                                <h6>{t("bnNumber")}</h6>
                                <h6>{company.companyVatNumber}</h6>
                            </div>
                            <div className="border-underline hidden-desk"></div>
                        </div>
                    }
                </Col>
                <div className="contact-us">
                    <span dangerouslySetInnerHTML={{ __html: t("ContactUs").replaceAll('\n', '</br>') }}></span>
                </div>
            </Row>
        </>
    )
}

export default CompanyConfirmation